import { Component } from '@angular/core';

@Component({
  selector: 'app-tests-report',
  standalone: true,
  imports: [],
  templateUrl: './tests-report.component.html',
  styleUrl: './tests-report.component.css'
})
export class TestsReportComponent {

}
